import BupSpinner from '@BUP/components/Loading/Spinner'
import InnerTable from './inner-table.jsx'

const SociogramTable = ({
  sociogram,
  surveysData,
  loadingSociogram,
  isLoadingDataSurveys,
  errorResultRecommendations
}) => {
  if (isLoadingDataSurveys || loadingSociogram) {
    return (
      <div className='loading_wrapper'>
        <BupSpinner size='large' />
      </div>
    )
  }

  return (
    <div className='inner-table-component'>
      <InnerTable
        surveysData={surveysData}
        sociogram={sociogram}
        loading={loadingSociogram || isLoadingDataSurveys}
        errorResultRecommendations={errorResultRecommendations}
      />
    </div>
  )
}

export default SociogramTable
